import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { DisplayField as CorgixDisplayField } from '@veeva/corgix/field';

const propTypes = {
    children: PropTypes.node,
    // we should not use className for writing css in css file.
    // This className is here so we can use emotion's css prop that it will get convert to classname by emotion
    className: PropTypes.string,
    label: PropTypes.node,
};

const DisplayField = ({ className, children, label }) => {
    return (
        <CorgixDisplayField
            className={className}
            css={css`
                label {
                    padding: 0;
                }
            `}
            label={label}
            hideBottomMessage
        >
            <div
                css={css`
                    overflow: hidden;
                    text-overflow: ellipsis;
                `}
            >
                {children}
            </div>
        </CorgixDisplayField>
    );
};

DisplayField.propTypes = propTypes;
export default DisplayField;
